module.exports = __webpack_public_path__ + "01-archivio-di-stato-roma.jpg?94360e1cd4c6986165b5901468d2f3dd";


//////////////////
// WEBPACK FOOTER
// ./src/img/gioco2/01-archivio-di-stato-roma.jpg
// module id = 382
// module chunks = 0